const ITEM_STOPLOSS_ALERT = 'portfoio-item-stoploss-alert';
const ITEM_REMOVE = 'watchlist-item-remove';
const ITEM_REMOVE_SUCCESS = 'watchlist-item-remove-succes';
const ITEM_TOGGLE = 'watchlist-item-toggle';
const ITEM_MOVE = 'watchlist-item-move';

export default {
	ITEM_STOPLOSS_ALERT,
	ITEM_REMOVE,
	ITEM_REMOVE_SUCCESS,
	ITEM_TOGGLE,
	ITEM_MOVE,
};
